module.exports = __webpack_public_path__ + "img/squelette-anatomie-face.feaeabd6.png";